const idCounts = {};

export default function uniqueId(id) {
  if (idCounts[id] === undefined) {
    idCounts[id] = 0;
    return id;
  }

  /* eslint-disable no-plusplus */
  return `${id}_${++idCounts[id]}`;
  /* eslint-enable no-plusplus */
}
